import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { Links } from '../../../docentes/materias/components/ListadoMateriasDocentes';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allTiposActividadesExtcurAction,
  deleteTiposActividadesExtcurAction,
  setActivoTiposActividadesExtcurAction,
} from '../TiposActividadesExtcurAction';
import { PARAMS_TIPOS_ACTIVIDADES_EXTRACUR } from '../TiposActividadesExtcurReducer';

const ListadoTiposActividadesExtcur = ({
  isDelete = false,
  setIsDelete = () => {},
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const tiposActividadesExtcurStore = Redux.useSelector(
    (state) => state.tiposActividadesExtcur,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};

      dispatch({ type: PARAMS_TIPOS_ACTIVIDADES_EXTRACUR, payload });
      if (
        tiposActividadesExtcurStore.all &&
        tiposActividadesExtcurStore.all.length === 0
      ) {
        await allTiposActividadesExtcurAction(dispatch, {
          ...tiposActividadesExtcurStore.params,
          ...payload,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = tiposActividadesExtcurStore.all.find((el) => el.id === id);
    await setActivoTiposActividadesExtcurAction(dispatch, data);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteTiposActividadesExtcurAction(
      { dispatch, notify },
      tiposActividadesExtcurStore.activo.id,
      tiposActividadesExtcurStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="1em"
              >
                {value}
              </NameComponent>
              {tiposActividadesExtcurStore.activo?.id ===
                tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip label="Editando" size="small" color="info" />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.link.name,
      label: CONST.link.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: '10vw',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              <Links target="_blank" href={value}>
                {value}
              </Links>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.desc.name,
      label: CONST.desc.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '-'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  setIsDelete(true);
                  const data = tiposActividadesExtcurStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoTiposActividadesExtcurAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={tiposActividadesExtcurStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={tiposActividadesExtcurStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {tiposActividadesExtcurStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {tiposActividadesExtcurStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoTiposActividadesExtcur;
